import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';

import {
  provideSignageRuntime, RuntimeProfile, SignageDataSource, SignageDisplayComponent, SignageRuntimeService
} from '@cubigo/digital-signage';

import { HttpSignageDataSourceService } from 'app/shared/services/data';
import { DisplayHealthService } from 'app/shared/services/display-health.service';

@Component({
  selector: 'app-home',
  imports: [SignageDisplayComponent],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    HttpSignageDataSourceService,
    { provide: SignageDataSource, useExisting: HttpSignageDataSourceService },
    provideSignageRuntime({ profile: RuntimeProfile.Display })
  ]
})
export class HomeComponent {
  private readonly runtime = inject(SignageRuntimeService);

  public constructor() {
    // The shell owns the heartbeat schedule and the device block; the runtime only contributes playback state.
    const detach = inject(DisplayHealthService).attach(() => this.runtime.diagnostics());
    inject(DestroyRef).onDestroy(detach);
  }
}
